import { RichTextMode } from '../components/RichText';

const getRichTextMode = (mode: string | null | undefined): RichTextMode => {
  if (!mode || mode.toString() === 'STANDARD') {
    return RichTextMode.STANDARD;
  } else if (mode.toString() === 'CENTER_HEADINGS') {
    return RichTextMode.CENTERED;
  } else if (mode.toString() === 'DIVIDER_HEADINGS') {
    return RichTextMode.MODE1;
  } else if (mode.toString() === 'SUBJECT_BLOCKS') {
    return RichTextMode.MODE2;
  } else if (mode.toString() === 'DIVIDER_GRID') {
    return RichTextMode.MODE3;
  } else if (mode.toString() === 'ACCORDION') {
    return RichTextMode.ACCORDION;
  }

  console.warn(`Unknown content mode: ${mode}`);
  return RichTextMode.STANDARD;
};

/*
Utility to retrieve nested value for Contentful LongText fields - *all* accesses of LongText fields should use this utility

This helps work around an issue where the Contentful ReST API schema doesn't match their GraphQL API - by using this utility our preview
capability can properly access LongText fields.
 */
const getLongTextValue = <T>(source: T, field: keyof T) => {
  if (source[field] && typeof source[field] === 'object') {
    return (source[field] as any)[field];
  }
  return source[field];
};

type AssetQueryData = {
  description?: string | null | undefined;
  file?:
    | {
        contentType?: string | null | undefined;
        url?: string | null | undefined;
      }
    | null
    | undefined;
  gatsbyImageData?: any | null | undefined;
  localFile?:
    | {
        publicURL?: string | null | undefined;
        childImageSharp?:
          | {
              gatsbyImageData?: any | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

type AssetInfo = {
  description: string | undefined;
  contentType: string | undefined;
  url: string | undefined;
  gatsbyImageData: any | undefined;
};

const getAssetInfo = (
  node: AssetQueryData | null | undefined,
): AssetInfo | undefined => {
  if (!node) {
    return undefined;
  }

  const result: AssetInfo = {
    description: undefined,
    contentType: undefined,
    url: undefined,
    gatsbyImageData: undefined,
  };

  result.description = node?.description || undefined;
  result.contentType = node?.file?.contentType || undefined;
  result.url = node?.localFile?.publicURL || node?.file?.url || undefined;
  result.gatsbyImageData =
    node?.localFile?.childImageSharp?.gatsbyImageData ||
    node?.gatsbyImageData ||
    undefined;

  return result;
};

const ContentfulUtils = {
  getRichTextMode,
  getLongTextValue,
  getAssetInfo,
};

export default ContentfulUtils;
